import React from 'react';
import { defineMessages } from 'react-intl';

import StaticSearch from 'Components/StaticSearch/StaticSearch';
import { fetchFreeToPlay } from 'Redux/ducks/algolia-calls';

const messages = defineMessages({
  title: {
    id: 'freetoplay.title',
    defaultMessage: 'Free To Play Games',
  },
  fullTitle: {
    id: 'freetoplay.seotitle',
    defaultMessage: 'Free To Play | Latest Free To Play Games',
  },
  desc: {
    id: 'freetoplay.seodesc',
    defaultMessage: 'Browse our selection of free-to-play games.',
  },
  seoBlurb: {
    id: 'freetoplay.seoBlurb',
    defaultMessage: 'If you\'re looking for a great deal you can\'t argue with free, so check out some of the best free to play titles we\'re fanatical about below. Take your pick from shooters to turn-based role-playing games, download and play today!',
  },
});


export default function LatestDeals() {
  return (<StaticSearch
    updateHits={fetchFreeToPlay}
    url="free-to-play"
    {...messages}
  />);
}
